export default __webpack_public_path__ + "static/media/product_avtar_Hk.d876c2e1.webp";